import React from 'react';
import { Delete, Edit } from '@mui/icons-material';
import { TimeOffReason } from '../../../../types';
import { schedulerService } from '../../../../core/services/schedulerService';
import styles from '../SchedulerSetting.module.scss';

interface TimeOffReasonsListProps {
	timeOffReasons: TimeOffReason[];
	onTimeOffReasonCreated: () => void;
	onEditClick: (reason: TimeOffReason) => void;
	canEdit?: boolean;
	canDelete?: boolean;
}

const TimeOffReasonsList: React.FC<TimeOffReasonsListProps> = ({ timeOffReasons, onTimeOffReasonCreated, onEditClick, canEdit = true, canDelete = true }) => {
	const handleDeleteClick = async (reason: TimeOffReason) => {
		if (!canDelete) return;
		if (timeOffReasons.length <= 1) return;
		const ok = window.confirm(
			`Are you sure you want to delete time off reason "${reason.name}"? This action cannot be undone.`
		);
		if (!ok) return;
		try {
			await schedulerService.deleteTimeOffReason(reason.id.toString());
			onTimeOffReasonCreated();
		} catch (e) {
			console.error('Failed to delete time off reason:', e);
		}
	};

	return (
		<>
			<div className={styles.tableContainer}>
				<table className={styles.workplaceTable}>
					<thead>
						<tr>
							<th>Reason</th>
							<th>Description</th>
							<th>Active</th>
							<th style={{ width: 48, textAlign: 'center' }}>Edit</th>
							<th style={{ width: 48, textAlign: 'center' }}>Delete</th>
						</tr>
					</thead>
					<tbody>
						{timeOffReasons.map((reason) => (
							<tr key={reason.id}>
								<td>
									<span>{reason.name}</span>
								</td>
								<td>
									<span>{reason.description || '-'}</span>
								</td>
								<td>
									<span>
										{reason.active ? 'Yes' : 'No'}
									</span>
								</td>
								<td style={{ textAlign: 'center', padding: '8px', width: 48 }}>
									<button
										className={styles.iconButton}
										title={canEdit ? "Edit" : "You do not have permission to edit"}
										onClick={() => onEditClick(reason)}
										disabled={!canEdit}
										style={{ opacity: canEdit ? 1 : 0.5, cursor: canEdit ? 'pointer' : 'not-allowed' }}
									>
										<Edit className={styles.editIcon} />
									</button>
								</td>
								<td style={{ textAlign: 'center', padding: '8px', width: 48 }}>
									<button
										onClick={() => handleDeleteClick(reason)}
										title={canDelete ? "Delete Reason" : "You do not have permission to delete"}
										className={styles.iconButton}
										disabled={!canDelete}
										style={{ opacity: canDelete ? 1 : 0.5, cursor: canDelete ? 'pointer' : 'not-allowed' }}
									>
										<Delete className={styles.deleteIcon} />
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</>
	);
};

export default TimeOffReasonsList;
